/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface VideoVisitConsentRequest {
  /** The ID of the encounter */
  encounter_id: string;
  /** Whether the patient consents to recording/transcription of the video visit. */
  consented: boolean;
}
